import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy border-t border-white/[0.06] py-16 px-6" data-id="element-150" data-mp="3ggtzeln15p6t">
      <div className="max-w-5xl mx-auto" data-id="element-151" data-mp="32ovukn0cqfgg">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-152" data-mp="32lrn9grlb3lk">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-153" data-mp="36nd5ziqt2c3o">
            <div className="flex items-center gap-2.5 mb-4" data-id="element-154" data-mp="3ueih5klswg7n">
              <img src="https://thruline-public.s3.us-west-1.amazonaws.com/brand/logos/png/logo-dark-trans.png" alt="Thruline" className="h-7 w-auto" data-id="element-155" data-mp="3ud7h9vvh7slt" />

            </div>
            <p className="text-white/40 text-sm leading-relaxed" data-id="element-156" data-mp="3ldu4ouc22nwv">
              Custom ERP software for manufacturing and operations companies.
            </p>
          </div>

          {/* Solutions */}
          <div data-id="element-157" data-mp="29xm1qrsppako">
            <h4 className="text-white text-xs font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-158" data-mp="2a19uhoqc1syc">
              Solutions
            </h4>
            <ul className="space-y-3" data-id="element-159" data-mp="3l90l3octskvk">
              <li data-id="element-160" data-mp="3la290texx1up">
                <Link to="/solutions" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-161" data-mp="3lbmu7sfd78fw">

                  All Solutions
                </Link>
              </li>
              <li data-id="element-162" data-mp="3v9axx7uy7qa7">
                <Link to="/pricing" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-163" data-mp="3v5n8okwjdq1a">

                  Pricing
                </Link>
              </li>
              <li data-id="element-164" data-mp="81fqhygiyw59">
                <Link to="/resources/integrations" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-165" data-mp="80xhs2coepgg">

                  Integrations
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-166" data-mp="cus0b2gjoydy">
            <h4 className="text-white text-xs font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-167" data-mp="cv1uz3cjbtpz">
              Resources
            </h4>
            <ul className="space-y-3" data-id="element-168" data-mp="qr5h09d98vrd">
              <li data-id="element-169" data-mp="mspppta55185">
                <Link to="/resources/blog" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-170" data-mp="mt7pv0zxbzlc">

                  Blog
                </Link>
              </li>
              <li data-id="element-171" data-mp="ytek6ham6csq">
                <Link to="/resources/case-studies" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-172" data-mp="yuzdy4p3trpj">

                  Case Studies
                </Link>
              </li>
              <li data-id="element-173" data-mp="18ksor3hfa2sq">
                <Link to="/resources/reference-guides" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-174" data-mp="18lbu7kpvyypv">

                  Reference Guides
                </Link>
              </li>
              <li data-id="element-175" data-mp="1hiulv7y1cbaq">
                <Link to="/resources/thesis" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-176" data-mp="1hmifs87e6zpz">

                  Our Thesis
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div data-id="element-177" data-mp="3oc6rt089t40k">
            <h4 className="text-white text-xs font-semibold tracking-[0.15em] uppercase mb-4" data-id="element-178" data-mp="3ocgg8jdo3345">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-179" data-mp="3tc2w70kvqxgn">
              <li data-id="element-180" data-mp="2afdhlagc14nq">
                <Link to="/about" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-181" data-mp="2afx12vlms13v">

                  About Us
                </Link>
              </li>
              <li data-id="element-182" data-mp="21ma637p8z1vq">
                <Link to="/about/careers" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-183" data-mp="21nlczgdzopr2">

                  Careers
                </Link>
              </li>
              <li data-id="element-184" data-mp="2te9cyp3xfp35">
                <Link to="/partners" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-185" data-mp="2tcoiezhm465a">

                  Become A Partner
                </Link>
              </li>
              <li data-id="element-186" data-mp="2kci7nldatk9t">
                <Link to="/contact" className="text-white/50 text-sm hover:text-white transition-colors" data-id="element-187" data-mp="2kc05y97vadui">

                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-188" data-mp="13z1klcp8xstq">
          <p className="text-white/30 text-xs" data-id="element-189" data-mp="2rvhg7o2icb82">
            © 2026 Thruline. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-190" data-mp="2wnhllw1cjwc1">
            <Link to="/terms" className="text-white/30 text-xs hover:text-white/60 transition-colors" data-id="element-191" data-mp="2woai846ld5gg">

              Terms & Conditions
            </Link>
            <Link to="/terms" className="text-white/30 text-xs hover:text-white/60 transition-colors" data-id="element-192" data-mp="2nuxm6td8dnq5">

              Privacy
            </Link>
            <a href="https://www.linkedin.com/company/thruline-hq/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 transition-colors" aria-label="LinkedIn" data-id="element-193" data-mp="3flbrw2b3btqq">

              <LinkedinIcon className="w-4 h-4" data-id="element-194" data-mp="36kdpfogavua9" />
            </a>
            <a href="#youtube" className="text-white/30 hover:text-white/60 transition-colors" aria-label="YouTube" data-id="element-195" data-mp="36mqbodt3cqt4">

              <YoutubeIcon className="w-4 h-4" data-id="element-196" data-mp="1v5gwi3gzwkxm" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}